import React from 'react';
import { Line } from "react-chartjs";

const chartOptions = {
    scaleShowHorizontalLines: true,
    responsive: true,
    barValueSpacing : 10,
};

const TokenActivityChart = ({chartData}) => {
    return (
        <div>
            <Line data={chartData} options={chartOptions}/>
        </div>
    );
};

export default TokenActivityChart;



// WEBPACK FOOTER //
// ./src/Regional-Views/Dashboard/graphs/tokenActivity.js